var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWwGooglePay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "980px",
    height: "680px",
    viewBox: "0 0 980 680",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "WW Google Pay") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEDED",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 900,
    height: 600,
    rx: 80
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-6.7%",
    y: "-10.0%",
    width: "113.3%",
    height: "120.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WW-Google-Pay",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(40, 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(50, 141)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.131834,155.005362 L378.131834,247.976309 L348.141206,247.976309 L348.141206,18.0481614 L426.116838,18.0481614 C445.110903,18.0481614 463.10528,25.0459745 477.100906,38.0419133 C491.096532,50.0381645 498.094346,68.0325412 498.094346,87.0266056 C498.094346,106.02067 491.096532,123.015359 477.100906,136.011298 C463.10528,149.007237 446.11059,156.00505 426.116838,156.00505 L378.131834,155.005362 L378.131834,155.005362 Z M378.131834,46.0394141 L378.131834,126.014422 L428.116214,126.014422 C439.112777,126.014422 450.109341,122.015672 457.107154,114.018171 C473.102156,99.0228568 473.102156,74.0306668 458.106842,59.0353529 C458.106842,59.0353529 457.107154,58.0356653 457.107154,58.0356653 C449.109653,50.0381645 439.112777,45.0397265 428.116214,46.0394141 L378.131834,46.0394141 L378.131834,46.0394141 Z",
    id: "Shape",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.07279,86.026918 C589.065917,86.026918 606.060606,92.0250436 619.056545,104.021295 C632.052484,116.017546 638.050609,132.012547 638.050609,152.006299 L638.050609,247.976309 L610.059356,247.976309 L610.059356,225.983182 L609.059669,225.983182 C597.063418,243.977558 580.068729,252.974747 560.074977,252.974747 C543.080287,252.974747 528.084973,247.976309 516.088722,237.979433 C505.092159,227.982557 498.094346,213.98693 498.094346,198.991617 C498.094346,182.996615 504.092471,170.000676 516.088722,160.0038 C528.084973,150.006924 545.079663,146.008174 565.073415,146.008174 C583.067791,146.008174 597.063418,149.007237 608.059981,156.00505 L608.059981,149.007237 C608.059981,139.010361 604.061231,129.013485 596.06373,123.015359 C588.066229,116.017546 578.069353,112.018796 567.07279,112.018796 C550.078101,112.018796 537.082162,119.016609 528.084973,133.012235 L502.093096,117.017234 C518.088097,96.023794 539.081537,86.026918 567.07279,86.026918 Z M529.084661,199.991304 C529.084661,207.988805 533.083411,214.986618 539.081537,218.985368 C546.07935,223.983806 554.076851,226.982869 562.074352,226.982869 C574.070603,226.982869 586.066854,221.984431 595.064042,212.987243 C605.060918,203.990055 610.059356,192.993491 610.059356,180.99724 C601.062168,173.999427 588.066229,170.000676 571.07154,170.000676 C559.075289,170.000676 549.078413,172.999739 541.080912,178.997865 C533.083411,183.996303 529.084661,190.994116 529.084661,199.991304 Z",
    id: "Shape",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#5F6368",
    points: "800 91.025356 701.030928 317.954441 671.0403 317.954441 708.028741 238.97912 643.049047 92.0250436 675.03905 92.0250436 722.024367 204.989742 723.024055 204.989742 769.009684 92.0250436 800 92.0250436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.16901,135.01161 C259.16901,126.014422 258.169322,117.017234 257.169634,108.020045 L132.208685,108.020045 L132.208685,159.004113 L203.186504,159.004113 C200.187441,174.999114 191.190253,189.994428 177.194627,198.991617 L177.194627,231.981307 L220.181193,231.981307 C245.173383,208.988493 259.16901,174.999114 259.16901,135.01161 Z",
    id: "Path",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.208685,263.97131 C168.197438,263.97131 198.188066,251.975059 220.181193,231.981307 L177.194627,198.991617 C165.198376,206.989117 150.203062,211.987555 132.208685,211.987555 C98.2193065,211.987555 68.2286785,188.994741 58.2318026,157.004737 L14.2455483,157.004737 L14.2455483,190.994116 C37.238363,235.980058 82.2243049,263.97131 132.208685,263.97131 Z",
    id: "Path",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2318026,157.004737 C52.233677,141.009736 52.233677,123.015359 58.2318026,106.02067 L58.2318026,72.0312916 L14.2455483,72.0312916 C-4.74851609,109.019733 -4.74851609,153.005987 14.2455483,190.994116 L58.2318026,157.004737 Z",
    id: "Path",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.208685,52.0375397 C151.202749,52.0375397 169.197126,59.0353529 183.192752,72.0312916 L183.192752,72.0312916 L221.180881,34.0431629 C197.188379,12.0500358 165.198376,-0.945903 133.208372,0.0537845977 C83.2239925,0.0537845977 37.238363,28.0450373 15.2452359,73.0309792 L59.2314902,107.020358 C68.2286785,75.0303544 98.2193065,52.0375397 132.208685,52.0375397 Z",
    id: "Path",
    fill: "#EA4335"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWwGooglePay);
export default __webpack_public_path__ + "static/media/WW Google Pay.212eef682c9eae469c13ea9b06c293e4.svg";
export { ForwardRef as ReactComponent };